import React from 'react';
import 'typeface-pacifico';
import './Header.scss';
import config from './config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCaretDown, faUser, faTimes, faSignOutAlt, faInfoCircle, faCrown } from '@fortawesome/free-solid-svg-icons';
import { faPaypal } from '@fortawesome/free-brands-svg-icons'
import moment from 'moment';
import { useAuth0 } from "@auth0/auth0-react";
import { User } from '@auth0/auth0-spa-js';


interface HeaderProps {
  getSubscriptionStatus :() => void;
  toast :(msg :string) => void
  toSplash :() => void
  signUp :() => void
  isSubscribed :boolean
  showDomains :() => void
  showSubscribe :() => void
  subscribedOn :Date | null
  showContact :() => void
  subscriptionID :string
  user :User | undefined
  isAuthenticated :boolean
  logout :() => void
  customerID :string
}

interface HeaderState {
  menuActive :boolean
  showAccountInfo :boolean
  showAbout :boolean
  showPricing :boolean
}

class Header extends React.Component<HeaderProps, HeaderState> {
  constructor(props) {
    super(props);
    this.cancelPlan = this.cancelPlan.bind(this);
    this.state = {
      menuActive: false, 
      showAccountInfo: false,
      showAbout : false,
      showPricing :false,
    }
  }

  cancelPlan() {
      const reason = window.prompt('Can you let me know why?');

      if(reason !== null) {
        fetch('/pro/cancel', {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          },
          body: JSON.stringify({ reason }),
        }).then(() => {
          this.setState({ showAccountInfo: false });
          this.props.getSubscriptionStatus();
          this.props.toast('Subscription cancelled');
        })
      }
  }

  logEvent(label) {
    try {
      window.gtag('event', label, {
        event_category: 'engagement',
        event_label: label
      })
    } catch {}
  }

  render() {
    return <div className="pk-header">
      {this.props.isAuthenticated && <>
      <nav className="navbar" role="navigation" aria-label="main navigation">
            <div className="navbar-brand pk-brand">
                <a onClick={this.props.toSplash}>peeklink</a>

              <a role="button" className={`navbar-burger burger ${this.state.menuActive && 'is-active'}`}
                aria-label="menu" aria-expanded="false" data-target="navbarBasicExample"
                onClick={() => this.setState({ menuActive: !this.state.menuActive })}>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </a>
            </div>

            <div id="navbarBasicExample" className={`navbar-menu ${this.state.menuActive && 'is-active'}`}>
              <div className="navbar-start"></div>
              <div className="navbar-end">
                <a className="navbar-item" onClick={this.props.showDomains}><FontAwesomeIcon icon={faGlobe} />Domains</a>

                {this.props.isSubscribed ?
                    <a className="navbar-item" onClick={() => {
                      if(this.props.customerID) {
                        // stripe-type subscription
                        window.location.href = `/pro/portal`;
                      } else {
                        this.setState({ showAccountInfo: true })}
                      }
                    }><FontAwesomeIcon icon={faUser} />Account</a>
                    : <a className="navbar-item" onClick={() => {this.props.showSubscribe(); this.logEvent('viewedUpgrade')}}><FontAwesomeIcon icon={faCrown} />Upgrade</a>}

                <a className="navbar-item"
                  onClick={this.props.logout}><FontAwesomeIcon icon={faSignOutAlt} />Log out</a>
              </div>
              </div>
          </nav></>}

          {!this.props.isAuthenticated && <>
          <div className="pk-brand">{this.props.toSplash ? <a onClick={this.props.toSplash}>peeklink</a> : 'peeklink'}</div>
            <div className="pk-menu">
              <a className="navbar-item" onClick={() => this.setState({ showAbout: true }, () => this.logEvent('viewedAbout'))}>About</a>
              <a className="navbar-item" onClick={() => this.setState({ showPricing: true }, () => this.logEvent('viewedPricing'))}>Pricing</a>
          <button className="navbar-item button" onClick={this.props.signUp}>Log in</button></div></>
          }

          {this.state.showAccountInfo && <div className="pk-account-info modal is-active">
              <div className="modal-background" onClick={() => this.setState({showAccountInfo: false})}></div>
                <div className="modal-card">
                <header className="modal-card-head">
                  <p className="modal-card-title">Account</p>
                  <button className="delete" aria-label="close" onClick={() => this.setState({showAccountInfo: false})}></button>
                </header>
                {this.props.subscribedOn ? <section className="modal-card-body content">
                  <table>
                    <tbody>
                      <tr>
                        <td><b>User</b></td>
                        <td>{this.props.user!.email}</td>
                      </tr>
                      <tr>
                        <td><b>Plan</b></td>
                        <td>Peeklink Pro (Pay as you go)</td>
                      </tr>
                      <tr>
                        <td><b>Expires</b></td>
                        <td>{moment(this.props.subscribedOn).add(7, 'days').format('LLL')}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="pk-about-questions">Questions? Feel free to <a onClick={this.props.showContact}>reach out</a>.</p>
                </section>
                :
                <section className="modal-card-body content">
                  <table>
                    <tbody>
                      <tr>
                        <td><b>User</b></td>
                        <td>{this.props.user!.email}</td>
                      </tr>
                      <tr>
                        <td><b>Plan</b></td>
                        <td>Peeklink Pro (Monthly)</td>
                      </tr>
                      <tr>
                        <td><b>View on Paypal</b></td>
                        <td><a href={`https://www.paypal.com/myaccount/autopay/connect/${this.props.subscriptionID}`} target="_blank">view</a></td>
                      </tr>
                      <tr>
                        <td><b>Cancel plan</b></td>
                        <td><a onClick={this.cancelPlan}>cancel</a></td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="pk-about-questions">Questions? Feel free to <a onClick={this.props.showContact}>reach out</a>.</p>
                </section>
              }
              </div>
          </div>}

        </div>
  }
}

export default Header;
